import { gql } from '@src/lib/gql'

/**
 * Badge counts for the My Advisors rail. `pageSize: 1` — only
 * `pagination.itemCount` is read. `all` omits `statusKeys` so the count is
 * every founder-owned seat.
 *
 * Collection `id` is deliberately not selected: root collections resolve it as
 * `null` in startups3 despite the `ID!` schema type, and omitting it keeps these
 * aliases un-normalized (and therefore distinct) in the Apollo cache.
 */
export const BOARD_SEAT_COUNTS = gql`
  query BoardSeatCounts {
    all: advisorEngagements(role: "FOUNDER", pageSize: 1) {
      pagination {
        itemCount
      }
    }
    drafts: advisorEngagements(role: "FOUNDER", statusKeys: ["draft"], pageSize: 1) {
      pagination {
        itemCount
      }
    }
    searching: advisorEngagements(role: "FOUNDER", statusKeys: ["searching"], pageSize: 1) {
      pagination {
        itemCount
      }
    }
    invited: advisorEngagements(role: "FOUNDER", statusKeys: ["invited"], pageSize: 1) {
      pagination {
        itemCount
      }
    }
    filled: advisorEngagements(role: "FOUNDER", statusKeys: ["active"], pageSize: 1) {
      pagination {
        itemCount
      }
    }
  }
`
